import React from "react";

export function StatusBadge({ status }) {
  const ongoing = status === "Ongoing";
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${
        ongoing
          ? "bg-teal/15 text-teal-dark animate-badge-glow"
          : "bg-navy/10 text-navy"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${ongoing ? "bg-teal" : "bg-navy"}`} />
      {status}
    </span>
  );
}
